import { Box, Flex, VStack } from '@chakra-ui/react';
import { Text } from '@diamond/shared/ui';

import { ReasonCancelIcon } from '../icons';
import { ReasonAlertItem } from './types';

const reasonCancelTextStyle = {
  fontFamily: 'Libre Franklin, -apple-system, system-ui, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal' as const,
  fontSize: '12px',
  lineHeight: '100%',
  letterSpacing: '0%',
};

export interface ReasonAlertBoxProps {
  groupedItems: Map<string, ReasonAlertItem[]>;
}

export function ReasonAlertBox({ groupedItems }: ReasonAlertBoxProps) {
  if (groupedItems.size === 0) {
    return null;
  }

  return (
    <>
      {Array.from(groupedItems.entries()).map(([reason, items]) => (
        <Box
          key={reason}
          bg="#FEF2F2"
          borderRadius="md"
          p={3}
          mb={2}
          data-testid="reason-alert-box"
        >
          <Flex align="center" gap={2} mb={2}>
            <ReasonCancelIcon boxSize="18px" color="red.500" />
            <Text color="red.500" {...reasonCancelTextStyle}>
              {reason}
            </Text>
          </Flex>
          <VStack align="stretch" spacing={2}>
            {items.map((item, index) => (
              <Flex
                key={`${item.product_name}-${index}`}
                justify="space-between"
                align="center"
              >
                <Text
                  color="gray.700"
                  noOfLines={1}
                  flex={1}
                  {...reasonCancelTextStyle}
                >
                  {item.product_name}
                </Text>
                <Text
                  color="gray.600"
                  flexShrink={0}
                  ml={2}
                  {...reasonCancelTextStyle}
                >
                  {item.quantity} {item.sales_unit}
                </Text>
              </Flex>
            ))}
          </VStack>
        </Box>
      ))}
    </>
  );
}
